import {FC} from 'react'
import {MultiTagFilteringFieldRow} from 'components/SearchForm/MultiTagFilteringFieldRow'
import {withNull} from 'libs/options'

const retireTypes = [
  {id: 'others', name: '一般退職'},
  {id: 'disability', name: '障害退職'},
  {id: 'passed_away', name: '死亡退職'},
]

export const RetireTypes: FC = () => {
  return (
    <MultiTagFilteringFieldRow header="退職区分" name="retireTypes" list={withNull(retireTypes)} shouldUnregister />
  )
}
